import { Button, SkeletonLoader } from '@civilgrid/ui/components';
import { useNavigate } from '@tanstack/react-router';
import { random } from 'lodash';
import { useMemo } from 'react';

interface Props {
  tabId: string;
}

export default function UnverifiedWall({ tabId }: Props) {
  const navigate = useNavigate();

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy
  const skeletonEls = useMemo(() => {
    const els = [];
    for (let i = 0; i < 200; i++) {
      els.push(<SkeletonLoader width={random(50, 150)} height={24} />);
    }
    return els;
  }, [tabId]);

  return (
    <div className="flex flex-grow flex-col text-center">
      <div className="flex flex-wrap">{skeletonEls}</div>
      <div className="absolute top-1/4 space-y-4 p-2">
        <div className="text-8xl">⚠️</div>
        <div className="space-y-4 bg-white p-2">
          <div className="text-lg">
            Oops, you can't access this page since you have not completed user verification.
          </div>

          <Button onClick={() => navigate({ to: '/verification' })} data-testid="unverified-wall-verify-button">
            Verify Now
          </Button>
        </div>
      </div>
    </div>
  );
}
